module.exports = __webpack_public_path__ + "img/award05_01.12def9e0.png";